module.exports = __webpack_public_path__ + "static/media/checkmark.f30630e7.svg";